import { groupAccountMapEntityName, groupEntityName, } from '../../../../backend/features/groups/shared';
export function getGroupStorage(context) {
    const groupAccountMapStorage = context.storage(groupAccountMapEntityName);
    const addAccountsToGroup = (groupId, accountIds) => {
        if (accountIds.length > 0) {
            removeAccountsFromGroup(groupId, accountIds);
            groupAccountMapStorage.massCreate(accountIds.map((accountId) => ({
                groupId: groupId,
                accountId: accountId,
            })));
        }
    };
    const removeAccountsFromGroup = (groupId, accountIds) => {
        if (accountIds && accountIds.length > 0) {
            groupAccountMapStorage.massDelete({
                filter: [
                    {
                        column: 'groupId',
                        op: '=',
                        value: groupId,
                    },
                    {
                        column: 'accountId',
                        op: 'in',
                        value: accountIds,
                    },
                ],
            });
        }
        else {
            groupAccountMapStorage.massDelete({
                filter: [
                    {
                        column: 'groupId',
                        op: '=',
                        value: groupId,
                    },
                ],
            });
        }
    };
    return Object.assign(Object.assign({}, context.storage(groupEntityName)), { addAccountsToGroup,
        removeAccountsFromGroup });
}
